
import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  Chip,
  Divider,
  Stack,
  Typography,
  Grid,
} from "@mui/material";
import { Phone, Email, Business, Person, Work } from "@mui/icons-material";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import { formatDuration } from "../../../utils/common";
import Loader from "../../../components/AnimatedLoader";
import ProfileImg from "../../../assets/user.png";
import { palette, theme as colorTheme} from "../../../Convoze.theme";



const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;
const secondary = colorTheme('palette', 'secondary').value
const night = colorTheme('palette', 'night').value


const iconMap = {
  "Full Name": <Person fontSize="small" />,
  Role: <Work fontSize="small" />,
  Email: <Email fontSize="small" />,
  Contact: <Phone fontSize="small" />,
  Industry: <Business fontSize="small" />,
  "Company Name": <Business fontSize="small" />,
};


const InfoCard = ({ label, value }) => (
  <Grid item xs={12} md={6}  marginBottom={4}>
    <Card
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 3,
        borderColor: "grey.200",
        height: "100%", 
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Avatar
          sx={{
            bgcolor: "transparent",
            color: primary,
            width : 40,
            height: 40,
          }}
        >
          {iconMap[label]}
        </Avatar>
        <Box>
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
          <Typography sx={{whiteSpace:"wrap"}} variant="body1" fontWeight={600} color="text.primary">
            {value}
          </Typography>
        </Box>
      </Stack>
    </Card>
  </Grid>
);

export default function Profile() {
  const token = localStorage.getItem("token");
  const [profile, setProfile] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axiosInstance.get(apiEndPointsConfig.userProfile, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProfile(res.data.data);
      } catch (e) {
        console.error("Profile fetch failed", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  if (loading) return <Loader />;

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: "0 8px 24px rgba(0,0,0,.05)",
        overflow: "visible",
      }}
    >
      {/* ---------- Header ---------- */}
      <Box
        sx={{
          position: "relative",
          height: 120,
          background: `linear-gradient(135deg, ${primary} 0%, ${primaryBg} 100%)`,
          borderRadius: "16px 16px 0 0",
        }}
      >
        <Avatar
          src={ProfileImg}
          alt={profile?.userName}
          sx={{
            width: 96,
            height: 96,
            border: "4px solid #fff",
            position: "absolute",
            bottom: -48,
            left: { xs: 16, sm: 32 },
            boxShadow: 3,
          }}
        />
      </Box>

      {/* ---------- Body ---------- */}
      <Stack spacing={3} sx={{ pt: 7, pb: 4 }}>
        {/* name + role + duration */}
        <Box sx={{ px: { xs: 3, sm: 4, md: 5 } }}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            spacing={2}
          >
            <Box>
              <Typography variant="h6" fontWeight={700}>
                {profile?.userName}
              </Typography>
              <Chip
                label={profile?.role}
                size="small"
                sx={{
                  mt: 0.5,
                  backgroundColor: "transparent",
                  border: 1,
                  // borderColor: "#6366F1",
                  borderColor : primary
                }}
              />
            </Box>

            {/* call duration */}
            <Box
              sx={{
                minWidth: 180,
                p: 2,
                bgcolor: "primary.50",
                borderRadius: 3,
                textAlign: "center",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Overall Call Duration
              </Typography>
              <Typography variant="h6" color={primary} fontWeight={700}>
                {formatDuration(profile?.formattedCallDuration) || "00:00:00"}
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Divider />

        {/* ---------- Info Cards ---------- */}
        <Box sx={{ px: { xs: 3, sm: 4, md: 3} }}>
          <Grid container spacing={3}>
            <InfoCard label="Full Name" value={profile?.userName || "NA"} />
            <InfoCard label="Role" value={profile?.role || "NA"} />
            <InfoCard
              label="Email"
              value={profile?.email || "info@triotech.in"}
            />
            <InfoCard label="Contact" value={profile?.mobile || "NA"} />
            <InfoCard label="Industry" value="SaaS" />
            <InfoCard label="Company Name" value="Trio-Tech" />
          </Grid>
        </Box>
      </Stack>
    </Card>
  );
}
